import React, { useMemo, memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ProductCardContainer, {
  getProductCardProps,
} from '@results/HOCs/ProductCardContainer';
import { Row } from '@components/Grid';
import StyledColItem from './StyledColItem';
import ProductCard from '../../../ProductCard';

const Container = styled.div`
  & > *:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.elementLine};
  }
`;

const getSectionsProducts = products => {
  const productList = products?.filter(x => x.enabled);
  return productList || [];
};

function SectionProducts({ products, onBeforeProductConfig }) {
  const filteredProducts = useMemo(() => getSectionsProducts(products), [
    products,
  ]);

  return (
    <Container>
      <Row columnable="md" id="section__products">
        {filteredProducts.map((product, index) => (
          <StyledColItem
            item
            flex="50"
            key={product.isFavourite ? `${product.id}_fav` : product.id}
          >
            <ProductCardContainer
              key={product.id}
              {...getProductCardProps(product)}
              onBeforeProductConfig={onBeforeProductConfig}
            >
              {onClick => (
                <ProductCard
                  index={index}
                  id={`product-card-${index}`}
                  key={product.id}
                  product={product}
                  withRating={product.rating > 0}
                  onClick={onClick}
                />
              )}
            </ProductCardContainer>
          </StyledColItem>
        ))}
      </Row>
    </Container>
  );
}

SectionProducts.propTypes = {
  products: PropTypes.array,
  onBeforeProductConfig: PropTypes.func.isRequired,
};

SectionProducts.defaultProps = {
  products: [],
};

export default memo(SectionProducts);
